import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { DataProvider, useStore, useSettings } from './listing-app/context/store';

import Filters from './filter-search/components/Filters';
import Search from './filter-search/components/Search';

function FilterSearch( props ) {
    const { 
        state,
    } = useStore();

    const settings = useSettings();

    return (
        <div className="filter-search">
            <Filters />
            <Search />
        </div>
    )
}

const app = document.getElementById( 'filter-search' );

if ( null !== app ) {
    ReactDOM.render(
        <DataProvider>
            <FilterSearch />
        </DataProvider>,
        app
    )
}